export enum PivotTableGroup {
  ROWS = 'rows',
  COLS = 'cols',
  VALUES = 'values',
}

export enum PivotTableLayout {
  CLASSIC,
  MODERN,
}
